import _ from 'lodash'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const getError = (formError, obj) => {
  const error = _.find(formError, (ele) => {
    return ele.path == obj
  })
  return error?.message || ''
}

export const handleDownload = async (title, url, type) => {
  if (type === 'pdf') {
    fetch(url, {
      method: 'get',
      credentials: 'include',
      xhrFields: {
        responseType: 'blob',
      },
    })
      .then((res) => res.blob())
      .then((data) => {
        var a = document.createElement('a')
        var url = window.URL.createObjectURL(data)
        a.href = url
        a.download = `${title}`
        document.body.append(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
      })
  } else {
    const a = document.createElement('a')
    a.href = await toDataURL(url)
    a.download = `${title}`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export const toDataURL = async (url) => {
  const blob = await fetch(url, { credentials: 'include' }).then((res) =>
    res.blob(),
  )
  return URL.createObjectURL(blob)
}
